import { NgModule } from '@angular/core';
import { PHBHPFeaturePackageElearningComponent } from './ph-bhp-feature-package-elearning.component';
import { PHBHPElearningComponent } from './ph-bhp-elearning/ph-bhp-elearning.component';
import { PHBHPManageelearningComponent } from './ph-bhp-manageelearning/ph-bhp-manageelearning.component';


import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PHBHPManagepuzzlesComponent } from './ph-bhp-managepuzzles/ph-bhp-managepuzzles.component';
import { PHBHPStartpuzzleComponent } from './ph-bhp-startpuzzle/ph-bhp-startpuzzle.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { ClientLibModule } from "../../ph-bhp-feature-package-check/lib/client-lib.module";
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/lib/ph-bhp-feature-components.module';

// common libraries

@NgModule({
    declarations: [PHBHPFeaturePackageElearningComponent, PHBHPElearningComponent, PHBHPManageelearningComponent, PHBHPManagepuzzlesComponent, PHBHPStartpuzzleComponent],
    imports: [
    PHBHPLayoutPackageModule,
    PHBHPLocalizePackageModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    PhBhpUiModule,
    ClientLibModule,
    PhBhpFeatureComponentsModule
],
    exports: [PHBHPFeaturePackageElearningComponent, PHBHPElearningComponent, PHBHPManageelearningComponent, PHBHPManagepuzzlesComponent, PHBHPStartpuzzleComponent]
})
export class PHBHPFeaturePackageElearningModule { }
